import { useEffect, useState } from 'react';

import './Dashboard.css';

import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import StatsCard from '../components/StatsCard';
import Chart from '../components/Chart';
import Activity from '../components/Activity';

import { supabase } from '../supabase/config';

const Dashboard = () => {

    const [users, setUsers] = useState([]);
    const [exhibitors, setExhibitors] = useState([]);
    const [bookings, setBookings] = useState([]);

    const getUsers = async () => {

        const { data, error } = await supabase
        .from('users')
        .select('*');

        if(data){
            setUsers(data);
        }

        if(error){
            console.log(error);
        }
    }


    const getExhibitors = async () => {

        const { data, error } = await supabase
        .from('exhibitors')
        .select('*');

        if(data){
            setExhibitors(data);
        }

        if(error){
            console.log(error);
        }
    }


    const getBookings = async () => {

        const { data, error } = await supabase
        .from('bookings')
        .select('*');

        if(data){
            setBookings(data);
        }

        if(error){
            console.log(error);
        }
    }


    useEffect(() => {

        getUsers();
        getExhibitors();
        getBookings();

    }, []);


    return (

        <div className="dashboard">

            <Sidebar />

            <div className="main-content">

                <Navbar />



                {/* Dashboard Header */}

                <div className="dashboard-header">

                    <h1>Dashboard Overview</h1>

                    <p>
                        Welcome back, Admin. Here's what's happening with your exhibition.
                    </p>

                </div>



                {/* Stats Cards */}

                <div className="stats-container">

                    <StatsCard
                        title="Total Users"
                        number={users.length}
                    />

                    <StatsCard
                        title="Exhibitors"
                        number={exhibitors.length}
                    />

                    <StatsCard
                        title="Bookings"
                        number={bookings.length}
                    />

                    <StatsCard
                        title="Revenue"
                        number="$284K"
                    />

                </div>



                {/* Middle Section */}

                <div className="middle-section">

                    <Chart />

                    <div className="quick-stats">

                        <h2>Quick Stats</h2>

                        <div className="quick-card">

                            <p>Pending Approvals</p>

                            <h3>12</h3>

                        </div>


                        <div className="quick-card">

                            <p>Active Exhibitors</p>

                            <h3>{exhibitors.length}</h3>

                        </div>


                        <div className="quick-card">

                            <p>New Users</p>

                            <h3>{users.length}</h3>

                        </div>

                    </div>

                </div>



                {/* Activity Section */}

                <div className="activity-section">

                    <h2>Recent Activity</h2>

                    {users.map((item) => (

                        <Activity
                            key={item.id}
                            name={item.name}
                            email={item.email}
                        />

                    ))}

                </div>
                <div className="dashboard-table">

    <div className="table-header">

        <h2>Recent Transactions</h2>

        <button>

            View All

        </button>

    </div>


    <table>

        <thead>

            <tr>

                <th>Visitor</th>
                <th>Ticket</th>
                <th>Status</th>
                <th>Amount</th>

            </tr>

        </thead>


        <tbody>

            <tr>

                <td>Ahmed Ali</td>

                <td>VIP</td>

                <td>

                    <span className="success">

                        Paid

                    </span>

                </td>

                <td>$120</td>

            </tr>


            <tr>

                <td>Sara Mohamed</td>

                <td>Premium</td>

                <td>

                    <span className="pending-payment">

                        Pending

                    </span>

                </td>

                <td>$80</td>

            </tr>


            <tr>

                <td>Omar Khaled</td>

                <td>Standard</td>

                <td>

                    <span className="success">

                        Paid

                    </span>

                </td>

                <td>$40</td>

            </tr>

        </tbody>

    </table>

</div>

            </div>

        </div>

    );
}

export default Dashboard;